import { render, staticRenderFns } from "./CommunityNav.vue?vue&type=template&id=2bf04106&scoped=true&"
import script from "./CommunityNav.vue?vue&type=script&lang=ts&"
export * from "./CommunityNav.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityNav.vue?vue&type=style&index=0&id=2bf04106&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf04106",
  null
  
)

export default component.exports